import axios from "axios";

let PublicAxios = axios.create({
    defaultInterceptors: true,
    headers: { "Access-Control-Allow-Origin": "*" },
});

export { PublicAxios }